/**
 * Поиск по свойству элемента в массиве
 * @param array
 * @param attr
 * @param value
 * @return {number}
 */
const indexOfProperty = function (array, attr, value) {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i
    }
  }
  return -1
}

export default indexOfProperty




// WEBPACK FOOTER //
// ./src/helpers/indexOfProperty.js